export default __webpack_public_path__ + "static/media/access_green.2cac9d70.svg";